import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { StringRequest } from "../../../siteadmin/school-type-setup/shared/StringRequest";
import { DataService_ExcuseSetup } from "../shared/data.service";
import { ExcuseInsertRequest } from "../shared/ExcuseInsertRequest";

@Component({
	selector: "app-admin-setup-add-excuse",
	templateUrl: "./admin-setup-add-excuse.component.html",
	styleUrls: ["./admin-setup-add-excuse.component.css"],
})
export class AdminSetupAddExcuseComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private adminSetupService: DataService_ExcuseSetup
	) {}

	ngOnInit(): void {
		this.user = this.dialogConfig.data.user;

		this.SchoolID = this.dialogConfig.data.SelectedSchool.SchoolID;
		this.SchoolName = this.dialogConfig.data.SelectedSchool.SchoolName;

		this.SchoolNameText = this.SchoolName;
	}

	///////////////////////////////////////
	// Data
	///////////////////////////////////////

	user: any;
	errorMessage: any = "";

	//Data from parent
	SchoolID: any;
	SchoolName: any;
	SchoolNameText: any;

	//Form Data
	Code: any = "";
	Desc: any = "";
	Excused: any = false;
	CountPresent: any = false;
	AllSchools: any = false;

	///////////////////////////////////////

	///////////////////////////////////////
	// Buttons
	///////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		//Error handling
		if (this.Code == "") {
			this.errorMessage = "Enter an excuse code";
			return;
		}

		if (this.Desc == "") {
			this.errorMessage = "Enter an excuse name or description";
			return;
		}

		this.CheckCode();
	}

	CheckCode() {
		let parms: StringRequest = {
			str: this.Code,
		};

		var result = this.adminSetupService.ExcuseCodeInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Excuse Code already in use";
					return;
				} else {
					this.CheckDesc();
				}
			},
			(error) => {}
		);
	}

	CheckDesc() {
		let parms: StringRequest = {
			str: this.Desc,
		};

		var result = this.adminSetupService.ExcuseDescInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Excuse Description already in use";
					return;
				} else {
					this.FinishAdd();
				}
			},
			(error) => {}
		);
	}

	FinishAdd() {
		var DefinedBy: any = this.user.UserLevelID == 1 ? 4 : 3;

		var sID = this.SchoolID;
		if (this.AllSchools == true) {
			sID = -1;
		}

		let parms: ExcuseInsertRequest = {
			ExcuseCD: this.Code,
			ExcuseDESC: this.Desc,
			IsExcusedInd: this.Excused == true ? 1 : 0,
			DefinedByID: DefinedBy,
			SchoolID: sID,
			IsCountAsPresent: this.CountPresent == true ? 1 : 0,
		};

		var result = this.adminSetupService.ExcuseInsert(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Excuse was created successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the Excuse",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////

	///////////////////////////////////////
	// Events
	///////////////////////////////////////
	onAllChange(val) {
		this.AllSchools = val;

		if (this.AllSchools == true) {
			this.SchoolNameText = "District";
		} else {
			this.SchoolNameText = this.SchoolName;
		}
	}

	///////////////////////////////////////

	///////////////////////////////////////
	// Helpers
	///////////////////////////////////////

	UserNotDistrictLevel() {
		return this.user.UserLevelID != 1;
	}

	///////////////////////////////////////
}
